import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const TrashIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 4H1.5C1.22 4 1 4.22 1 4.5C1 4.78 1.22 5 1.5 5H2V15C2 15.55 2.45 16 3 16H13C13.55 16 14 15.55 14 15V5H14.5C14.78 5 15 4.78 15 4.5C15 4.22 14.78 4 14.5 4ZM6 13C6 13.55 5.55 14 5 14C4.45 14 4 13.55 4 13V7C4 6.45 4.45 6 5 6C5.55 6 6 6.45 6 7V13ZM9 13C9 13.55 8.55 14 8 14C7.45 14 7 13.55 7 13V7C7 6.45 7.45 6 8 6C8.55 6 9 6.45 9 7V13ZM12 13C12 13.55 11.55 14 11 14C10.45 14 9.99999 13.55 9.99999 13V7C9.99999 6.45 10.45 6 11 6C11.55 6 12 6.45 12 7V13ZM14 1H10C10 0.45 9.55 0 9 0H7C6.45 0 6 0.45 6 1H2C1.45 1 1 1.45 1 2V3H15V2C15 1.45 14.55 1 14 1Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default TrashIcon;
